var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_vm.topBannerData ? _c('div', [_c('b-carousel', {
    staticStyle: {
      "text-shadow": "1px 1px 2px #333"
    },
    attrs: {
      "id": "carousel-1",
      "interval": 4000,
      "controls": _vm.topBannerData.length > 1,
      "indicators": _vm.topBannerData.length > 1,
      "background": "#ababab",
      "img-width": "1024",
      "img-height": "480"
    },
    on: {
      "sliding-start": _vm.onSlideStart,
      "sliding-end": _vm.onSlideEnd
    },
    model: {
      value: _vm.slide,
      callback: function ($$v) {
        _vm.slide = $$v;
      },
      expression: "slide"
    }
  }, _vm._l(_vm.topBannerData, function (image, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function ($event) {
          return _vm.goToLink(image.navigateTo);
        }
      }
    }, [_c('b-carousel-slide', {
      staticClass: "cursor-pointer",
      attrs: {
        "img-src": image.url.fileUrl
      }
    })], 1);
  }), 0)], 1) : _vm._e()])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }